module.exports = __webpack_public_path__ + "fonts/Barlow-Light.865a0a17.ttf";